import React from "react";
import { Link } from 'react-router-dom'

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import List from '../../components/List'
import Grid from '../../components/Grid'
import Image from '../../components/Image'

import image from '../../assets/images/1.jpeg'
import image3 from '../../assets/images/3.jpeg'

import image4 from '../../assets/images/brandbook/balance1.svg'
import image5 from '../../assets/images/brandbook/balance2.svg'
import image6 from '../../assets/images/brandbook/sensor.jpg'

export const path = '/brandbook/brand-strategy'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">
          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Waved</span> <br />Brand Strategy</h1>
            </>
          </Grid>
        </Container>
      </Hero>

      <Container size="large">

      <Section>

      <Grid grid="1-2">
      <></>

      <>
        <h2>Balance is key</h2>
        <p>Waved is all about finding the right balance.
        How we find the balance is unique for each occasion — we might reduce the noise,
        or boost the volume to get the party started.
        Our starting point is neutral, centered and in the middle.
        </p>
        <p>
        Waved always use just the right amount of volume to get our message through.
        The way we talk, build our product and visualize our brand are all important parts.
        The elements work together, and make sure we communicate clearly and make people recognize our brand.
         </p>
      </>
    </Grid>
    </Section>
    <Section>
      <Grid>
      <>
        <Image imageUrl={image5} aspect="1/1" />
        <p>Balance in layout and alignment. </p>
      </>
      <>
        <Image imageUrl={image4} aspect="1/1" />
        <p>Balance in contrast and shapes. </p>
      </>

      </Grid>
    </Section>
      <Section>

        <Grid grid="1-2">
        <></>
        <>
          <h2>Essence</h2>
          <p>
            We make sure people thrive when they are together.
            Waved are the secret hero that helps companies to create and tailor the perfect mood and atmosphere.
            Waved is smart and dynamic, the X factor that makes everything work.
          </p>

          <h2>Position</h2>
          <p>
            Waved cooperate instead of competing. We know that we need
            work together with others to reach our goals. Knowing that without Waved an essensial
            piece is missing makes us confident — but with no need to brag.
            Waved is integrating rather than separating, to make everything work seamlessly.
          </p>

          <h2>People</h2>
          <p>
            Waved speaks with:
          </p>

            <List large items={[
                  'Owners, managers and key personnel in hospitality and retail',
                  'Vendors and providers of sound and light systems',
                  'Special interest groups for accessibility',
                ]}
              />
          </>
          </Grid>
          </Section>

          <Section>
            <Grid>
              <Image imageUrl={image6} aspect="1/1" />
               <Image imageUrl={image3} aspect="1/1" />
            </Grid>
          </Section>

          <Section>

          <Grid grid="1-2">
          <></>

          <>
            <h2>Goals</h2>
            <p>Waved communicates to:</p>

            <List items={[
                'Increase sale in hospitality and retail',
                'Take care of our existing clients',
                'Find new solutions for sale and cooperation with vendors',
                'Encourage interest groups to work together with us',
              ]}
            />

          </>
        </Grid>
      </Section>

    <br />
    </Container>
    </div>
    )
  }
